export default (betSelections, selectedBets) => betSelections.map(
    bet => selectedBets.find(selectedBet =>
        selectedBet.outcomersId === bet.selectionId
        && selectedBet.eventId === bet.eventId,
    ),
)



// WEBPACK FOOTER //
// /src/js/common/utils/getSelectedBetsForMultiples.js